import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customCurrency',
  standalone: true
})
export class CustomCurrencyPipe implements PipeTransform {
  transform(value: any): string {
    if (value === null || value === undefined || value === '') return '$0.00';

    let numericValue: number;
    if (typeof value === 'string') {
      const cleanString = value.replace(/[^0-9.-]+/g, '');
      numericValue = parseFloat(cleanString);
    } else {
      numericValue = value;
    }
    if (isNaN(numericValue)) {
      return '$0.00';
    }
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(numericValue);
  }
}
